module.exports = __webpack_public_path__ + "img/gitlab.21a922e1.png";